export interface ScheduleDraft {
  title: string;
  localTime: string;
  timeZone: string;
  allowGuests: boolean;
  haramModeDefault: boolean;
}

const scheduleDraftKey = `${talkBrand.guestStoragePrefix}:schedule-draft:v1`;
const scheduleDraftLifetimeMs = 7 * 24 * 60 * 60 * 1000;

interface StoredScheduleDraft extends ScheduleDraft {
  savedAt: number;
}

function validDraft(value: unknown): value is StoredScheduleDraft {
  if (!value || typeof value !== "object") return false;
  const draft = value as Partial<StoredScheduleDraft>;
  return typeof draft.title === "string"
    && draft.title.length <= 100
    && typeof draft.localTime === "string"
    && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(draft.localTime)
    && typeof draft.timeZone === "string"
    && draft.timeZone.length > 0
    && draft.timeZone.length <= 100
    && typeof draft.allowGuests === "boolean"
    && (draft.haramModeDefault === undefined || typeof draft.haramModeDefault === "boolean")
    && typeof draft.savedAt === "number"
    && Number.isFinite(draft.savedAt);
}

export function saveScheduleDraft(draft: ScheduleDraft): void {
  try {
    window.sessionStorage.setItem(scheduleDraftKey, JSON.stringify({ ...draft, savedAt: Date.now() } satisfies StoredScheduleDraft));
  } catch {
    // Storage can be unavailable in hardened browser modes; the form still works in memory.
  }
}

export function loadScheduleDraft(now = Date.now()): ScheduleDraft | null {
  try {
    const stored = window.sessionStorage.getItem(scheduleDraftKey);
    if (!stored) return null;
    const parsed: unknown = JSON.parse(stored);
    if (!validDraft(parsed) || now - parsed.savedAt > scheduleDraftLifetimeMs) {
      clearScheduleDraft();
      return null;
    }
    return { title: parsed.title, localTime: parsed.localTime, timeZone: parsed.timeZone, allowGuests: parsed.allowGuests, haramModeDefault: parsed.haramModeDefault === true };
  } catch {
    clearScheduleDraft();
    return null;
  }
}

export function clearScheduleDraft(): void {
  try {
    window.sessionStorage.removeItem(scheduleDraftKey);
  } catch {
    // Nothing else needs to happen if storage is unavailable.
  }
}
import { talkBrand } from "./brand";
